import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';
import { observer } from 'mobx-react';
import Header from './header-component/header';
import Sidebar from './sidebar-component/sidebar';
import ChatSidebar from './ChatSidebar';
import Footer from './footer';
// import ThemeCustomizer from './common/theme-customizer';
import Loader from '../../components/loader';
import appState from '../../storages/mobx/appState';
import NotificationStatus from '../../components/NotificationStatus';

const AppLayout = (props) => (
  !appState.isReady ? <Loader /> : (
    <div className={`page-wrapper ${props.className}`}>
      <div className="page-body-wrapper">
        <Header />
        <Sidebar />
        <ChatSidebar />
        <div className="page-body">
          { props.children }
        </div>
        <Footer />
        {/* <ThemeCustomizer /> */}
      </div>
    </div>
  )
);

export default observer(AppLayout);
